import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useRoiIndustryContext } from "../../../context/roi/industry/RoiIndustryContext";
import Table from "../../../components/table/Table";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { faCols_roiIndustryStocks } from "../../../components/tableHeaderNames/HeaderName";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";
import RoiPersonalWatchStocksForm from "./RoiPersonalWatchStocksForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  outline: "none",
  borderRadius: "12px",
};

const highlightedCols = [
  "daily_roi",
  "weekly_roi",
  "monthly_roi",
  "quarterly_roi",
  "half_yearly_roi",
  "yearly_roi",
  "three_years_roi",
];

export default function RoiPersonalWatchStocks() {
  const { isStocksModal, setIsStocksModal, selectedWatch } =
    useRoiPersonalWatchContext();

  const handleClose = () => setIsStocksModal(false);

  const myStocks = useSWR(
    selectedWatch.id
      ? `/favorite/favorite-roi-instruments/${selectedWatch.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60000,
    }
  );

  return (
    <Modal open={isStocksModal} onClose={handleClose}>
      <Box sx={style}>
        <Table
          tableData={myStocks}
          tableTitle={{ title: "سهم‌ها", desc: selectedWatch.name }}
          faCols={faCols_roiIndustryStocks}
          height={"70vh"}
          highlightedCols={highlightedCols}
          Form={RoiPersonalWatchStocksForm}
        />
      </Box>
    </Modal>
  );
}
